function checkOrganizationProperty(aId, aProperty, aDefaultValue) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lProperty,
        lValue = false;

    if (!isNullOrUndefined(aDefaultValue)) {
        lValue = aDefaultValue;
    }
    lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Name', aProperty, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lProperty = query(getDataItems('OrganizationProperty'), lBuilder.RootExpression);
    for (var lKey in lProperty) {
        if (lProperty.hasOwnProperty(lKey)) {
            lProperty = lProperty[lKey];
            break;
        }
    }

    if (lProperty && lProperty.Value) {
        lValue = lProperty.Value;
    }
    return lValue;
}
if (isNullOrUndefined(veritracks)) {
    throw ('ORI.js requires the veritracks namespace defined in Default.js');
}



(function(window,checkOrganizationProperty, isNullOrUndefined, mEnrolleesData){
    //ORI Propperty
    /**
     * @param  {} property
     */
    function GetOriProperty(OrganizationId,property){
        if (isNullOrUndefined(property)) {
            throw ('GetOriProperty requires a property to be passed.');
        }
        var regexNumbersOnly = /[^a-z ]\ *([.0-9])*\d/,
            regexLettersOnly = /([A-Z]|[a-z])/,
            regexIsYFlag = /Y/,regexIsNFlag =/N/ ,
            value = null;
        if(OrganizationId != null){
            value = checkOrganizationProperty(OrganizationId, property);
            if(regexNumbersOnly.test(value)){
                //is a Number
                return parseFloat(value);
            }else if (regexLettersOnly.test(value)){
                //is a String
                var booleanY = regexIsYFlag.test(value), booleanN = regexIsNFlag.test(value);
                if(booleanY || booleanN){
                    return (value == 'Y');
                }else {
                    return value;
                }
                
            }
        }
        return value;
    }
    //expose function
   
    if (isNullOrUndefined(veritracks.core)) {
        window.veritracks.core = {};
    }
    if (isNullOrUndefined(veritracks.orui)) {
        window.veritracks.core.ori = {};
    }
    //expose fn property 
    /**
     * @namespace
     */
    window.veritracks.core = {
        "GetOriProperty":GetOriProperty
    };
        /**
     * Easy Class to quickly manage organization property
     * @param  {} aOrganizationId
     */
    window.OrganizationController = function(aOrganizationId){
        this.Id = aOrganizationId;
        this.IsPropertySupported = function(aProperty){
            return veritracks.core.GetOriProperty(this.Id, aProperty);
        };
    };
})(window,checkOrganizationProperty, isNullOrUndefined, mEnrolleesData);

